module.exports = __webpack_public_path__ + "static/brandbox-pricingBG-collab-1079d1402d08fab6770b858af84d16db.png";